import { numHex } from './numHex';

export function strHex(s: string) {
  var a = '';
  for (var i = 0; i < s.length; i++) {
    a = a + numHex(s.charCodeAt(i));
  }
  return a;
}
